
export class Position{
    private latitude:number;
    private longitude:number;
    private altitude:number;

    constructor(latitude:number, longitude:number, altitude: number){
        this.longitude=longitude;
        this.latitude=latitude;
        this.altitude=altitude;
    }

    public getLongitude():number{
        return this.longitude;
    }
    public getAltitude():number{
        return this.altitude;
    }
    public getLatitude():number{
        return this.latitude;
    }
}